console.log('🌟 process.env.CDN_ENV', process.env.CDN_ENV)
console.log('🌟 process.env.RUNTIME', process.env.RUNTIME)
if (!process.env.CDN_ENV || !process.env.RUNTIME) {
  console.error('找不到 process.env.CDN_ENV 或 process.env.RUNTIME, 请检查编译配置！')
}


const BASE_URL_MAP = {
  cdn: {
    development: '/meemo-test/',
    test: '/meemo/',
    preview: '/meemo/',
    production: '/meemo/'
  },
}

const BASE_URL = BASE_URL_MAP[process.env.RUNTIME][process.env.CDN_ENV]

const CDN_MAP = {
  cdn: {
    development: 'meemo-test-ssr/dist/client',
    test: 'meemo-test-ssr/dist/client',
    preview: 'meemo-pre-ssr/dist/client',
    production: 'meemo-ssr/dist/client'
  },
}

const CDN_PATH = process.env.CDN_PATH || CDN_MAP[process.env.RUNTIME][process.env.CDN_ENV]

console.log('🌟 BASE_URL', BASE_URL)
console.log('🌟 CDN_PATH', CDN_PATH)

module.exports = {
  BASE_URL,
  CDN_PATH
}
